// manages user capabilities
import Constants from "lib/Constants";
import ApiService from "services/ApiService";
import AuthService from "services/AuthService";
import FacebookService from "services/providers/FacebookService";
import { now, validateMonthString } from "utils/DateUtils";
import LocalStorage from "utils/LocalStorage";
const moment = require('moment');

class UserService {

    constructor() {
    }

    updateUser = (user) => {
        return new Promise((resolve, reject) => {
            ApiService.post('/users/profile', user)
                .then((r: any) => {
                    if (!r.success) {
                        return reject(r);
                    }
                    LocalStorage.set(Constants.CURRENT_USER, r.user);
                    resolve(r.user);
                })
                .catch(e => reject(e));
        });
    }

    getRevenueGoal = (month?: string, pollForResult: 'true' | 'false' = 'true') => {
        month = month && validateMonthString(month) ? month : now().format('YYYY-MM');
        return new Promise((resolve, reject) => {
            ApiService.get(`/users/revenue-goal/${month}?poll=${pollForResult}`)
                .then((r: any) => {
                    if (!r.success) {
                        return reject(r.error || 'No revenue goal found.');
                    }

                    const { taskId, predictions } = r;
                    if (taskId) {
                        ApiService.pollForTaskCompletion(taskId)
                            .then(async () => {
                                return this.getRevenueGoal(month, 'false');
                            })
                            .then(goal => resolve(goal))
                            .catch(error => reject(error));
                    } else if (predictions) {
                        return resolve(predictions);
                    } else {
                        reject('No revenue goal found.');
                    }
                })
                .catch(error => reject(error));
        });
    }

    deleteAccount = async (id) => {
        return ApiService.delete(`/users/${id}`);
    }

    public updateAccountCurrency = async (user) => {
        try {
            if (user.activeAccount) {
                user.activeAccount.currency = currency;
                let { currency } = await FacebookService.getAccountMetadata(user.activeAccount.accountId);
                let update = await ApiService.post(`/users/active-account/currency`, { currency });
                await AuthService.updateCurrentUser(user);
                return currency;
            }
        } catch (error) {
            return 'USD';
        }
    }

    public updatePaymentMethod = async (paymentId) => {
        return new Promise((resolve, reject) => {
            ApiService.post('/users/payment-method', { paymentMethod: paymentId })
                .then(r => {
                    if (!r.success) {
                        return reject(r);
                    }
                    // todo: should only update user's subscription object?
                    LocalStorage.set(Constants.CURRENT_USER, r.user._doc);
                    resolve(r.user._doc);
                })
                .catch(e => reject(e))
        });
    }

    public getTrackingForAccount = async (user, account, domains) => {
        return new Promise((resolve, reject) => {
            if (!account || !account._id) return reject("Account is missing.");
            ApiService.post('/tracking/get-tracking', { accountId: account._id, domains })
                .then(r => {
                    if (!r.success) {
                        return reject(r);
                    }
                    resolve(r.tracking);
                })
                .catch(e => reject(e))
        });
    }

    // Returns object: { needsConversion, convertFrom, convertTo }
    public getCurrencyConversionStatus = async (user) => {
        //convert currencies
        let accountCurrencies = await this.getAccountCurrencies(user);
        let needsConversion = false;
        let fbCurrency = accountCurrencies['Facebook'];
        let shopifyCurrency = accountCurrencies['Shopify'];
        let convertFrom = fbCurrency ? fbCurrency : process.env.DEFAULT_CURRENCY;
        let convertTo = shopifyCurrency ? shopifyCurrency : process.env.DEFAULT_CURRENCY;

        if ((fbCurrency && shopifyCurrency)) {
            if (fbCurrency != shopifyCurrency) {
                convertFrom = fbCurrency;
                convertTo = shopifyCurrency;
            }
        }

        if (convertFrom != convertTo) {
            needsConversion = true;
        }

        return { needsConversion, convertFrom, convertTo };
    }

    // Gets a json object which details the currencies defined for each provider (later used for currency conversions).
    public getAccountCurrencies = async (user) => {
        let currencies = { 'default': process.env.DEFAULT_CURRENCY };
        user.activeAccount.providers.forEach(p => {
            currencies[p.name] = (p.data && p.data.currency) ? p.data.currency : process.env.DEFAULT_CURRENCY;
        });
        return currencies;
    }

}

export default new UserService();